<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: value => ['enter', 'cmd_enter'].includes(value),
  },
});

const { t } = useI18n();

const sendLabel = computed(() =>
  props.variant === 'enter'
    ? t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.ENTER_KEY.PREVIEW_SEND')
    : t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.CMD_ENTER_KEY.PREVIEW_SEND')
);
</script>

<template>
  <div
    class="relative w-full h-[100px] rounded-lg overflow-hidden bg-gradient-to-r from-n-solid-2 to-n-brand/15 dark:to-n-brand/25"
  >
    <div
      class="absolute top-2.5 left-2 w-[202px] h-3 rounded-full bg-n-solid-3"
    />
    <div
      class="absolute top-[30px] left-2 w-[137px] h-3 rounded-full bg-n-solid-3"
    />
    <div
      class="absolute bottom-4 right-2 flex items-center justify-center h-7 px-3 rounded-md bg-n-brand text-white text-xs font-medium shadow-sm"
      :class="variant === 'cmd_enter' ? 'min-w-[104px]' : 'min-w-[78px]'"
    >
      {{ sendLabel }}
    </div>
  </div>
</template>
